import api from './api';
import {
  AgendaAvailabilitySettings,
  AgendaDayException,
  AgendaEntry,
  AgendaHolidayImportResult,
  CreateAgendaDayExceptionDTO,
  CreateAgendaEntryDTO,
  PublicAgendaAvailability,
  PublicAgendaSlot,
  UpdateAgendaAvailabilityDTO,
  UpdateAgendaEntryDTO,
} from '../types/agenda';

export const agendaService = {
  getMyEntries: async () => {
    const response = await api.get<AgendaEntry[]>('/api/v1/professional-agenda');
    return response.data;
  },

  getPublicEntries: async (professionalId: number) => {
    const response = await api.get<PublicAgendaSlot[]>(`/api/v1/professional-agenda/public/${professionalId}`);
    return response.data;
  },

  getAvailability: async () => {
    const response = await api.get<AgendaAvailabilitySettings>('/api/v1/professional-agenda/availability');
    return response.data;
  },

  updateAvailability: async (payload: UpdateAgendaAvailabilityDTO) => {
    const response = await api.put<AgendaAvailabilitySettings>('/api/v1/professional-agenda/availability', payload);
    return response.data;
  },

  getExceptions: async () => {
    const response = await api.get<AgendaDayException[]>('/api/v1/professional-agenda/exceptions');
    return response.data;
  },

  createException: async (payload: CreateAgendaDayExceptionDTO) => {
    const response = await api.post<AgendaDayException>('/api/v1/professional-agenda/exceptions', payload);
    return response.data;
  },

  deleteException: async (exceptionId: number) => {
    const response = await api.delete<{ id: number; deleted: boolean }>(`/api/v1/professional-agenda/exceptions/${exceptionId}`);
    return response.data;
  },

  importHolidays: async (country: string, year: number) => {
    const response = await api.post<AgendaHolidayImportResult>(
      `/api/v1/professional-agenda/exceptions/import-holidays?country=${encodeURIComponent(country)}&year=${year}`
    );
    return response.data;
  },

  getPublicAvailability: async (professionalId: number) => {
    try {
      const response = await api.get<PublicAgendaAvailability>(
        `/api/v1/professional-agenda/public/${professionalId}/availability`
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return {
          works_monday: true,
          works_tuesday: true,
          works_wednesday: true,
          works_thursday: true,
          works_friday: true,
          works_saturday: false,
          works_sunday: false,
          holiday_country: 'BG',
          non_working_dates: [],
          working_override_dates: [],
          non_working_exceptions: [],
        };
      }
      throw error;
    }
  },

  createEntry: async (payload: CreateAgendaEntryDTO) => {
    const response = await api.post<AgendaEntry>('/api/v1/professional-agenda', payload);
    return response.data;
  },

  updateEntry: async (entryId: number, payload: UpdateAgendaEntryDTO) => {
    const response = await api.patch<AgendaEntry>(`/api/v1/professional-agenda/${entryId}`, payload);
    return response.data;
  },

  deleteEntry: async (entryId: number) => {
    const response = await api.delete<{ id: number; deleted: boolean }>(`/api/v1/professional-agenda/${entryId}`);
    return response.data;
  },
};
